import { createFileRoute } from '@tanstack/react-router'
import LaunchBriefSection from 'Work/components/Work/Sections/LaunchBrief/LaunchBriefSection'

export const Route = createFileRoute('/work/$workId/launch-brief')({
    component: LaunchBriefSection,
})
